import { t } from "i18next"
import { SELECTED_TAB_KEY, USERTYPES } from "../../../constants/Constants"
import { YourReportsIcon } from "../../../components/SVGComponents/YourReportsIcon"
import { SampleReportTemplatesIcon } from "../../../components/SVGComponents/SampleReportTemplatesIcon"
import CustomReportTemplateIcon from "../../../components/SVGComponents/CustomReportTemplateIcon"
import { Icon } from "@fluentui/react"

export const tabDetailsForSuperAdmin = (selectedValue) => [
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "1",
        title: t("report-templates.custom-report"),
        contentClass: "tabContent",
        icon: (
            <YourReportsIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "1"}
            />
        ),
    },
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "2",
        title: t("report-templates.augmento-report"),
        contentClass: "tabContent",
        icon: (
            <SampleReportTemplatesIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "2"}
            />
        ),
    },
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "3",
        title: t("report-templates.firm-report"),
        contentClass: "tabContent",
        icon: (
            <CustomReportTemplateIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "3"}
            />
        ),
    }
]


export const tabDetailsForFirmUsers = (selectedValue) => [
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "1",
        title: t("report-templates.client-report"),
        contentClass: "tabContent",
        icon: (
            <CustomReportTemplateIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "1"}
            />
        ),
    }
]

export const tabDetailsForRadiologist = (selectedValue) => [
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "1",
        title: t("report-templates.custom-report"),
        contentClass: "tabContent",
        icon: (
            <YourReportsIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "1"}
            />
        ),
    },
    {
        id: SELECTED_TAB_KEY.REPORTTEMPLATE + "2",
        title: t("report-templates.augmento-report"),
        contentClass: "tabContent",
        icon: (
            <SampleReportTemplatesIcon
                active={selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "2"}
            />
        ),
    },
]

export const reportTemplateInitialFilterObj = {
    modalityIds: [],
    clientIds: [],
    radiologistIds: []
  };

export const getTabDetailsBasedOnRole = (selectedValue, role) => {
    if (role === USERTYPES.ADMIN) {
        return tabDetailsForSuperAdmin(selectedValue)
    } else if (role === USERTYPES.FIRMADMIN || role === USERTYPES.SUPERVISOR) {
        return tabDetailsForFirmUsers(selectedValue)
    } else if (role === USERTYPES.RADIOLOGIST) {
        return tabDetailsForRadiologist(selectedValue)
    } else {
        return [];
    }
}

export const checkAccessForCustomTab = (selectedValue, role) => {
    if ((role === USERTYPES.ADMIN || role === USERTYPES.RADIOLOGIST) && selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "1") {
        return true;
    }
    return false;
}

export const checkAccessForAugmentoTab = (selectedValue, role) => {
    if ((role === USERTYPES.ADMIN || role === USERTYPES.RADIOLOGIST) && selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "2") {
        return true;
    }
    return false;
}

export const checkAccessForClientTab = (selectedValue, role) => {
    if (((role === USERTYPES.SUPERVISOR || role === USERTYPES.FIRMADMIN) && selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "1") || (role === USERTYPES.ADMIN && selectedValue == SELECTED_TAB_KEY.REPORTTEMPLATE + "3")) {
        return true;
    }
    return false;
}


export const CustomReportTemplateColumn = (role, userData, handleEdit, deleteConfirmModal) => {
    return [
        {
            id: "username",
            style: { width: "30vw" },
            headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left" },
            headerClass: "break-word column-user-details-header",
            classChildName:
                "break-word cursor-pointer",
            header: () => (
                <span className="">Details</span>
            ),
            accessor: "clients",
            accessorKey: "clients",
            show: true,
            cell: (info) => {
                const index = info.row.index;
                // console.log(info)
                return <>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>

                            <div style={{ display: 'flex' }}>
                                {/* <div className="user-heading">Title:&nbsp;</div> */}
                                <div className="user-sub-heading">{info.row.original.title}</div>
                            </div>
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <div className="user-heading" style={{ fontSize: "12px" }}>Modality:&nbsp;</div>
                                <div className="user-sub-heading">{info.row.original.modality.name}</div>
                            </div>
                            {role === USERTYPES.ADMIN && (
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span className="user-heading" style={{ fontSize: "12px" }}>Radiologist :&nbsp;</span>
                                    <span className="user-sub-heading">
                                        {userData[index]?.username}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div style={{ width: "20%", alignItems: "center", display: "flex", justifyContent: "space-around" }}>
                            <Icon
                                iconName="Edit"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    handleEdit(info.row.original.id)
                                }}
                            ></Icon>
                            <Icon
                                iconName="delete"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => deleteConfirmModal(info.row.original.id)}
                            ></Icon>
                        </div>
                    </div>
                </>
            }
        }
    ];
}

export const ClientReportTemplateColumn = (role, clientData, handleEdit, deleteConfirmModal) => {
    return [
        {
            id: "username",
            style: { width: "30vw" },
            headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left" },
            headerClass: "break-word column-user-details-header",
            classChildName:
                "break-word cursor-pointer",
            header: () => (
                <span className="">Details</span>
            ),
            accessor: "clients",
            accessorKey: "clients",
            show: true,
            cell: (info) => {
                const index = info.row.index;
                return <>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                            <div style={{ display: 'flex' }}>
                                {/* <div className="user-heading">Title:&nbsp;</div> */}
                                <div className="user-sub-heading">{info.row.original.title}</div>
                            </div>
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <div className="user-heading" style={{ fontSize: "12px" }}>Modality:&nbsp;</div>
                                <div className="user-sub-heading">{info.row.original.modality.name}</div>
                            </div>
                            {(role === USERTYPES.ADMIN || role === USERTYPES.FIRMADMIN || role === USERTYPES.SUPERVISOR) && (
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span className="user-heading" style={{ fontSize: "12px" }}>Client :&nbsp;</span>
                                    <span className="user-sub-heading">
                                        {clientData[index]?.name}
                                    </span>
                                </div>
                            )}
                        </div>
                       <div style={{ width: "20%", alignItems: "center", display: "flex", justifyContent: "space-around" }}>
                            <Icon
                                iconName="Edit"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    handleEdit(info.row.original.id)
                                }}
                            ></Icon>
                            <Icon
                                iconName="delete"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => deleteConfirmModal(info.row.original.id)}
                            ></Icon>
                        </div>
                    </div>
                </>
            }
        }
    ];
}

export const AugmentoReportTemplateColumn = (role, handleEdit, deleteConfirmModal) => {
    return [
        {
            id: "username",
            style: { width: "30vw" },
            headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left" },
            headerClass: "break-word column-user-details-header",
            classChildName:
                "break-word cursor-pointer",
            header: () => (
                <span className="">Details</span>
            ),
            accessor: "clients",
            accessorKey: "clients",
            show: true,
            cell: (info) => {
                return <>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                            <div style={{ display: 'flex' }}>
                                {/* <div className="user-heading">Title:&nbsp;</div> */}
                                <div className="user-sub-heading">{info.row.original.title}</div>
                            </div>
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <div className="user-heading" style={{ fontSize: "12px" }}>Modality:&nbsp;</div>
                                <div className="user-sub-heading">{info.row.original.modality.name}</div>
                            </div>
                        </div>
                        {role !== USERTYPES.RADIOLOGIST && <div style={{ width: "20%", alignItems: "center", display: "flex", justifyContent: "space-around" }}>
                            <Icon
                                iconName="Edit"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    handleEdit(info.row.original.id)
                                }}
                            ></Icon>
                            <Icon
                                iconName="delete"
                                style={{
                                    // color: "white",
                                    fontSize: 17,
                                    lineHeight: "44px",
                                    marginRight: "15px",
                                    cursor: "pointer"
                                }}
                                onClick={() => deleteConfirmModal(info.row.original.id)}
                            ></Icon>
                        </div>}
                    </div>
                </>
            }
        }
    ];
}